/* Lesestatus der Meldungen: Speicherschlüssel je Nutzer und Übernahme der alten,
 * nutzerlosen Schlüssel. Reine Funktionen, der Speicher wird hereingereicht
 * (localStorage im Browser, ein Attrappen-Objekt im Test).
 *
 * Vorher lagen die Werte unter festen Schlüsseln ohne Nutzerkennung — wer im
 * selben Browser das Konto wechselte, erbte den Stand des vorigen Kontos.
 */

export const READ_IDS_BASE = 'grh_notifReadIds';
export const BASELINE_BASE = 'grh_notifLastSeen';

export function readIdsKey(userId) {
  return `${READ_IDS_BASE}_${userId}`;
}

export function baselineKey(userId) {
  return `${BASELINE_BASE}_${userId}`;
}

function readJson(storage, key) {
  try {
    const raw = storage.getItem(key);
    return raw == null ? null : JSON.parse(raw);
  } catch {
    return null;
  }
}

function writeJson(storage, key, value) {
  try {
    storage.setItem(key, JSON.stringify(value));
  } catch {
    /* nicht kritisch: gilt dann nur für diese Sitzung */
  }
}

/**
 * Stand des Nutzers laden. Hat er noch keinen eigenen Eintrag, aber es liegen
 * noch die alten Schlüssel vor, werden diese für ihn übernommen und danach
 * gelöscht — sonst bekäme jedes weitere Konto im selben Browser dieselbe
 * Ausgangslage, also genau den Fehler, der hier behoben wird. Übernommen wird
 * damit vom ersten Konto, das sich nach dem Update anmeldet.
 *
 * Liefert { readIds: Set, baseline: number }.
 */
export function loadReadState(storage, userId) {
  let ids = readJson(storage, readIdsKey(userId));
  let base = readJson(storage, baselineKey(userId));

  if (ids == null && base == null) {
    const legacyIds = readJson(storage, READ_IDS_BASE);
    const legacyBase = readJson(storage, BASELINE_BASE);
    if (legacyIds != null || legacyBase != null) {
      ids = legacyIds;
      base = legacyBase;
      if (ids != null) writeJson(storage, readIdsKey(userId), ids);
      if (base != null) writeJson(storage, baselineKey(userId), base);
      try {
        storage.removeItem(READ_IDS_BASE);
        storage.removeItem(BASELINE_BASE);
      } catch {
        /* nicht kritisch */
      }
    }
  }

  return {
    readIds: new Set(Array.isArray(ids) ? ids : []),
    baseline: Number(base) || 0,
  };
}

export function saveReadIds(storage, userId, ids) {
  writeJson(storage, readIdsKey(userId), [...ids]);
}

export function saveBaseline(storage, userId, baseline) {
  writeJson(storage, baselineKey(userId), baseline);
}
